<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row m-2 align-items-center">
              <div class="col mt-4 d-none d-sm-block">
                <h4 class="rental-heading">CA Related Payments</h4>
              </div>
               <div class="col mt-4 d-block d-sm-none">
                <h4 class="rental-heading">CA  Payments</h4>
              </div>
               <div class="col d-flex justify-content-end">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary d-none d-sm-block new-btn"
                @click="BackToServices()"
              >
                Back To Services
              </llp-button>
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary d-block d-sm-none new-btn"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
            </div>
          </div>
        </div>
          <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row rental-payment">
              <div class="col">
                <div class="row mt-2 p-0">
                  <div class="d-flex justify-content-end">
                    <div class="col-lg-1 col-md-3 col-sm-4 rental-btn">
                      <llp-button
                        :load-spinner="showaddUserSpinner"
                        classNames="btn-secondary new-btn"
                        type="button"
                        @click:button="PayAmount()"
                      >
                        Pay
                      </llp-button>
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-4" v-if="roleId == 4">
                      <llp-button
                        :load-spinner="showaddUserSpinner"
                        classNames="btn-secondary new-btn"
                        type="button"
                        @click:button="addCAPayments()"
                      >
                      <i class="fa-solid fa-plus"></i>
                        Add CA Payments
                      </llp-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col position-relative">
                <div v-if="loading" class="loader-overlay">
            <div class="spinner"></div>
                    </div>
                <llp-datatable
                  ref="usersTable"
                  :columns="columns"
                  :data="CaRelatedUser"
                  :lazy="true"
                  :paginator="true"
                  :totalRecords="totalRecords"
                  scrollable
                  @onPageChange="onPageChange"
                >
                  <template #actions="{ data }">
                    <div class="text-center">
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="ViewCAPaymentDetails(data.id)"
                      >
                          <i class="fa fa-eye"></i>
                      </button>
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="EditCAPaymentDetails(data.id)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <!-- <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="DeleteCAPaymentDetails(data.id)"
                      >
                         <i class="fa fa-trash"></i>
                      </button> -->
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="PayBill(data.id)"
                      >
                        <i class="fa fa-credit-card"></i>
                      </button>
                    </div>
                  </template>
                </llp-datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
export default {
    setup() {},
     data() {
    return {
      loading:false,
       currentPage: 1,
      perpage: 10,
      totalRecords: 0,
      columns: [
        {
          field: "name",
          className: "text-center",
          header: "Name",
        },
        { field: "address", className: "text-center", header: "Address" },
        {
          header: "Actions",
          body: "actions",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
        },
      ],
      CaRelatedUser:[],
      showaddadminSpinner: false,
       serviceId:this.$route.params.serviceId,
        roleId:localStorage.getItem("role_id"),
      userId:localStorage.getItem('User_id')
    };
  },
mounted()
{
    this.resetDataTable();
  this.fetchingCARelatedUser()
},
watch: {
    "$route.params.roleName": function () {
      this.resetDataTable();
    },
  },
    methods:{
         BackToServices() {
        this.$router.back();
    },

 resetDataTable: function () {
      this.rows = [];
      this.totalRecords = 0;
      this.$refs.usersTable.resetPaginator();
    },
     onPageChange(event) {
      const { first, rows } = event;
      this.currentPage = first / rows + 1;
      this.perpage = rows;
       this.loading = true; 
      this.fetchingCARelatedUser(this.currentPage, this.perpage);
    },
     async fetchingCARelatedUser()
    {
      const requestData = {
          page: this.currentPage,
          per_page: this.perpage,
        };
        try {
          this.loading = true;
        const DonationResponseData = await NetworkService.get(
          `get-service-list/${this.userId}/${this.serviceId}`,requestData
        );
        this.CaRelatedUser = DonationResponseData.details;
         this.totalRecords = DonationResponseData.pagination.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
       if(error.message)
      {
        this.$refs.toast.show(error.message,"error")
      }else{
          this.$refs.toast.show(
          "Unable to fetching the ca related payment user details.",
          "error"
        );
      }
      }
    },
     addCAPayments() {
      this.$router.push({name:'AddCaRelatedPayments',params:{serviceId:this.serviceId}});
    },
    EditCAPaymentDetails(id)
    {
        this.$router.push({name:'EditCARelatedPayments', params: {serviceId: this.serviceId,id:id }})
    },
    ViewCAPaymentDetails(id)
    {
        this.$router.push({name:'ViewCARelatedPayments', params: {serviceId: this.serviceId,id:id }})

    },
//     DeleteCAPaymentDetails(id) {
//   const index = this.DonationPayments.findIndex(payment => payment.id === id);
//   if (index !== -1) {
//     this.DonationPayments.splice(index, 1);
//       this.$refs.toast.show("CA related payment user is  deleted successfully.", "success");
//   }
// },

    PayBill(id){
        this.$router.push({name:'PayCAPaymentPayment',params:{serviceId:this.serviceId,id:id}})
    },
    PayAmount()
    {
        this.$router.push({name:'PayCAPaymentPayment',params:{serviceId:this.serviceId}})
    }
    }
}
</script>
